import CompanyLogo from "@components/company_logo.tsx";
import LoadingSkeleton from "./loading_skeleton.tsx";

type Props = {
  loading?: boolean;
  company: string;
  logoUrl: string;
};
const ResultLogo = ({ loading, company, logoUrl }: Props) => {
  return loading ? (
    <LoadingSkeleton className="h-[60px] w-[60px]" />
  ) : (
    <CompanyLogo companyName={company} logoUrl={logoUrl} />
  );
};

export default ResultLogo;
